import { Result } from './model';
export var asExactly = function (expected) { return function (value, path) {
    if (value === expected) {
        return Result.ok(expected);
    }
    else {
        return Result.error([{ path: path, expected: "exactly " + JSON.stringify(expected) }]);
    }
}; };
